import type { CategoryItem } from '@/mocks/categories';

interface CategoryGridProps {
  title: string;
  subtitle?: string;
  items: CategoryItem[];
  imageUrls: string[];
}

const categoryDescriptions: Record<string, string> = {
  'Shoes': 'Discover the latest footwear styles',
  'Hoodies/Sweaters': 'Cozy and stylish top picks',
  'T-Shirts': 'Essential everyday basics',
  'Jackets': 'Layer up with premium outerwear',
  'Pants/Shorts': 'Bottoms for every occasion',
  'Headwear': 'Caps, hats and more',
  'Sets': 'Curated matching collections',
  'underwear/underpants': 'Everyday comfort essentials',
  'Jersey': 'Sport and casual jersey selections',
  'Accessories': 'Complete your look',
  'Bags': 'Carry your essentials in style',
  'Belts': 'Finishing touch accessories',
  'Perfumes': 'Signature scents and fragrances',
  'OtherStuff': 'More amazing finds',
};

export default function CategoryGrid({ title, subtitle, items, imageUrls }: CategoryGridProps) {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-none mb-3">
            {title}
          </h2>
          {subtitle && (
            <p className="text-base text-foreground-500">{subtitle}</p>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.slice(0, 3).map((cat, i) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative w-full h-[280px] md:h-[320px] overflow-hidden bg-background-100">
                <img
                  src={imageUrls[i] || ''}
                  alt={`${cat.name} category - OOPBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="font-heading text-xl font-bold text-white mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-white/70">
                    {categoryDescriptions[cat.name] || 'Explore this category'}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}